<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">氢能</span> > 加氢站月报</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>加氢站月报</p>
        <div class="btn fr" @click="search">搜索</div>
        <input class="fr" type="text" v-model="queryParams.likeFileTitle" placeholder="请输入关键词">
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p @click="downloadReport(item)">{{ item.fileTitle }}</p>
          <span class="fr">{{ item.showYearTime }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;" @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="queryParams['pageSize']"
          :current-page="queryParams['pageNum']"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;" @click="goLast">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  monthList,
  monthDetail
} from '@/api/hydrogen'

export default {
  data() {
    return {
      list: [],
      total: 0,
      queryParams:{
        pageNum:1,
        pageSize:15,
        likeFileTitle:'',
        fileType:'9',
        sourceType:11
      }
    }
  },
  created() {
    if (this.$route.query&&this.$route.query['flag']) {
      this.queryParams['fileType'] = this.$route.query['flag'];
    }
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      monthList(this.queryParams).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    /**
     * 下载文件
     */
    downloadReport(row) {
      monthDetail(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['氢能', '相关报告', '正文'], row['id']);
      })
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.queryParams['fileType'] = num;
      this.queryParams['pageNum'] =1;
      this.getList();
    },
    /**
     * 搜索
     */
    search() {
      this.queryParams['pageNum'] = 1;
      this.getList()
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/hydrogen')
    },

    /**
     * 分页
     */
    goFirst() {
      this.queryParams['pageNum'] = 1;
      this.getList()
    },
    goLast() {
      this.queryParams['pageNum'] = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.queryParams['pageNum'] = page;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
